import { render, staticRenderFns } from "./AiAppSettingDefinitionEdit.vue?vue&type=template&id=5f50ccc0&scoped=true&"
import script from "./AiAppSettingDefinitionEdit.vue?vue&type=script&lang=js&"
export * from "./AiAppSettingDefinitionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f50ccc0",
  null
  
)

export default component.exports